import { render, staticRenderFns } from "./Command-page.vue?vue&type=template&id=11240455&"
import script from "./Command-page.vue?vue&type=script&lang=js&"
export * from "./Command-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports